import { Spinner } from "react-bootstrap";
import { Add, Edit } from "iconsax-react";
import DBButton from "../DBButton";
import "./styles.scss";

export default function DBAddButton(props) {
    return (
        <DBButton
            className="db-add-button"
            {...props}
            caption={
                props.icon ||
                (props.editMode ? (
                    <Edit size="18" color="#2e71fc" />
                ) : (
                    <Add size="24" color="#2e71fc" />
                ))
            }
            outlined
        />
    );
}
